/**
 * Persists an admin-uploaded brewery logo to canonical brewery doc and override doc.
 */
export async function saveBreweryLogoUrls({
  breweryId,
  logoUrl,
  db,
  doc,
  writeBatch,
}) {
  const breweryDocRef = doc(db, 'breweries', breweryId);
  const overrideDocRef = doc(db, 'breweryOverrides', breweryId);
  const values = { logoUrl };

  const batch = writeBatch(db);
  batch.set(breweryDocRef, values, { merge: true });
  batch.set(
    overrideDocRef,
    { ...values, parentBreweryId: breweryId },
    { merge: true },
  );
  await batch.commit();
}
